<template>
  <div>
    <!-- 查詢區 -->
    <el-card shadow="always" style="margin: 0 auto; margin-top: 5px;">
      <el-row type="flex" :gutter="10" style="flex-wrap: wrap;">
        <el-col :xs="24" :sm="12" :md="8" style="margin-bottom: 10px;">
          <div>店家</div>
          <el-select v-model="qStoreId" placeholder="選擇店家" style="width: 100%;" filterable>
            <el-option 
              v-for="item in qStoreIdData"
              :key="item.code"
              :label="item.disName"
              :value="item.code"
            />
          </el-select>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8" style="margin-bottom: 10px;">
          <div>車號</div>
          <el-input placeholder="車號" v-model="qCarNo" style="width: 100%;">
            <template slot="prepend">車號</template>
          </el-input>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="10" style="flex-wrap: wrap;">
        <el-col :xs="12" :sm="6" :md="4" style="margin-bottom: 10px;">
          <el-button type="primary" @click="query" style="width: 100%">查詢</el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- 表格區 -->
    <el-card shadow="always" style="margin: 0 auto; margin-top: 10px;">
      <div style="overflow-x: auto;">
        <el-table :data="tableData" stripe border style="">
          <el-table-column fixed="left" prop="carNo" label="車號" width="120" />
          <el-table-column prop="storeId" label="店家" :formatter="fter_store" width="140"/>
          <el-table-column prop="clientOrderId" label="訂單狀態" width="140">
            <template slot-scope="scope">
              <el-tag :type="scope.row.clientOrderId ? 'danger' : 'success'">
                {{ scope.row.clientOrderId ? '租借中' : '空閒' }}
              </el-tag>
            </template> 
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="primary" size="small" v-if="!scope.row.clientOrderId && scope.row.ecoAuto" @click="openEcoSeat(scope.row)">開廂</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-pagination
        background
        layout="prev, pager, next"
        style="margin-top:10px"
        :total="pageTotal"
        :current-page.sync="pageCurrent"
        @current-change="query"
      />
    </el-card>

    <!-- 編輯視窗 -->
    <el-dialog title="編輯視窗" :visible.sync="dialogFormVisible">
      <!-- 編輯內容 -->
    </el-dialog>
  </div>
</template>


<script>
export default {
  data () {
    return {
      qStoreId: '',
      qStoreIdData: [],
      qCarNo:'',
      pageTotal: 0,
      pageCurrent: 1,
      dialogFormVisible: false,
      tableData: [],
      form: {
        areaId: '',
        disName: ''
      },
      formLabelWidth: '120px',
      rules: {
        disName: [
          { required: true, message: '無法為空值', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.$axios.get('../api/params/getParams',{})
        .then((res)=>{
          this.$store.dispatch('login',res.data)
          if (res.data.authStores.length>=1) {
            this.qStoreIdData.push({code:'',disName:'全部'})
          }
          res.data.authStores.forEach(e => {
            this.qStoreIdData.push(e)
          })
          this.query()
      }).catch((res)=>{
          if(res.response.status==401){
            window.location = '/';
          }        
      });
  },
  name: 'AdminProdControl',
  components: {},
  computed: {},
  methods: {
    query () {
      this.$axios.get('../api/prod/getProds', {
        params: {
          qStoreId: this.qStoreId,
          qCatId: this.qCatId,
          qCarNo: this.qCarNo,
          page: this.pageCurrent
        }
      }).then((res) => {
        this.tableData = res.data.data
        this.pageTotal = res.data.pageTotal
      })
    },
    openEcoSeat(row){
      console.log(row)
      this.$confirm("是否確定開啟車廂", "注意", {
        confirmButtonText: "確定",
        cancelButtonText: "取消"
      }).then(() => {
        this.fullscreenLoading = true
        let params = { 
          ecoAuto: row.ecoAuto,
          isEcoProd: row.isEcoProd,
          iotType: row.iotType
        }
        this.$axios.post('../api/prod/openEcoSeat', params)
          .then((res) => {
            if (res.data.rs === 'success') {
              this.$alert("車聯網連線測試完成", "結果", { confirmButtonText: "確定" });
            } else {
              this.$alert("車聯網連線失敗，請檢查車輛資料的車機設定", "結果", { confirmButtonText: "確定" });
            }
            this.fullscreenLoading = false
          })
      })
    },
    fter_store(row, column) {
      let storeId = row[column.property];
      if (storeId == undefined) return "";
      return this.$storeDisName(this.$store.state.stores, storeId);
    },
  }
}
</script>
